<template>
  <div id="app">
    <NavBar />
    <router-view />
  </div>
</template>

<script>
import NavBar from "@/components/NavBar.vue";
import { db } from "@/firebase";
import { mapState } from "vuex";
import { detect } from "detect-browser";
import Logger from "@/mediasoup-client/Logger";

const logger = new Logger("App.vue");

export default {
  name: "App",
  components: {
    NavBar,
  },
  computed: {
    ...mapState({
      role: (state) => state.mediasoup.role,
    }),
  },
  watch: {
    role(val) {
      if (val === "proxy") {
        let htmlElement = document.querySelector("html");
        htmlElement.style.overflow = "hidden";
      }
    },
  },
  async created() {
    // if (this.$store.getters.getCurrentUser == null) {
    //   await auth.signInAnonymously();
    // }
    let firebaseCheck = null;
    setTimeout(() => {
      try {
        if (!firebaseCheck) {
          throw "Could not connect to Firebase";
        }
        logger.info("Firebase connection check OK.");
      } catch (error) {
        const msg = `IPs:
firestore.googleapis.com -> floating ips
socket.qonda.cloud -> floating ips
mediasoup.qonda.cloud -> 18.159.85.247
v2.goqonda.io -> 151.101.1.195 | 151.101.65.195
app.goqonda.io -> 151.101.1.195 | 151.101.65.195
Für Konferenz Admins: cloudfunctions.net

Destination ports - UDP/TCP Ports:
80; 443; 4443; 5000;40000-49999`;
        const msgHtml = `<p>Could not connect to Firebase. Either the server is unreachable 
        or your firewall blocks the connection. Contact your IT administrator to allow the following 
        IPs and Ports:</p><br>
        <p>firestore.googleapis.com -> floating ips</p>
        <p>socket.qonda.cloud -> floating ips</p>
        <p>mediasoup.qonda.cloud -> 18.159.85.247</p>
        <p>v2.goqonda.io -> 151.101.1.195 | 151.101.65.195</p>
        <p>app.goqonda.io -> 151.101.1.195 | 151.101.65.195</p>
        <p>Für Konferenz Admins: cloudfunctions.net</p><br>
        <p>Destination ports - UDP/TCP Ports:</p>
        <p>80; 443; 4443; 5000;40000-49999</p>`;
        this.$buefy.snackbar.open({
          message: msgHtml,
          position: "is-top",
          actionText: "Copy & Close",
          indefinite: true,
          onAction: () => {
            navigator.clipboard.writeText(msg);
          },
        });
        throw "Could not connect to Firebase";
      }
    }, 10000);
    try {
      const testDocRef = await db.doc(`test/8DDruOucCAQew5kBYzDF`);
      await testDocRef.set(
        {
          test: "updated",
        },
        { merge: true },
      );
      const testDoc = await testDocRef.get();
      firebaseCheck = testDoc.data();
    } catch (error) {
      console.error("Firebase error:", error);
      throw "Could not connect to Firebase";
    }

    // Opening the feedback snackbar
    setTimeout(() => {
      this.$buefy.snackbar.open({
        type: "is-primary",
        duration: 6000,
        message: this.$t("feedbackText"),
        position: "is-bottom-right",
        cancelText: "Close",
        actionText: "feedback page",
        onAction: () => {
          window.open("https://www.provenexpert.com/qonda/d6tn/", "_blank");
        },
      });
    }, 1800000);
    // let app = {
    //   messages: [],
    //   connect() {
    //     /*
    //      * See https://html.spec.whatwg.org/multipage/indices.html#events-2
    //      * for details around each WebSocket event type.
    //      */

    //     // WebSocket sends a message to API Gateway on creation that gets
    //     // routed to the '$connect' route
    //     const websocket = (this.websocket = new WebSocket(
    //       "wss://socket.qonda.cloud"
    //     ));

    //     websocket.onclose = ({ wasClean, code, reason }) => {
    //       this.messages.push(
    //         `onclose:   ${JSON.stringify({ wasClean, code, reason })}`
    //       );
    //       this.connect();
    //     };

    //     websocket.onerror = error => {
    //       logger.info(error);
    //       this.messages.push(
    //         "onerror:   An error has occurred. See console for details."
    //       );
    //     };

    //     websocket.onmessage = ({ data }) => {
    //       try {
    //         let tmp = JSON.parse(data);
    //         if (tmp.action === "redirect") {
    //           window.location.href = tmp.data;
    //         }
    //         if (tmp.action === "message") {
    //           alert(tmp.data);
    //         }
    //       } catch (e) {
    //         console.error(e);
    //       }
    //       this.messages.push(`onmessage: ${data}`);
    //     };

    //     websocket.onopen = () => {
    //       this.messages.push("onopen:    Connected successfully.");
    //     };
    //   },
    //   send() {
    //     this.messages.push("client:    Sending a message.");

    //     this.websocket.send(
    //       // This message will be routed to the '$default' route as 'routeB'
    //       // has not been defined
    //       JSON.stringify({ action: "message", data: "Hello from client." })
    //     );
    //     setTimeout(() => {
    //       this.websocket.send(
    //         // This message will be routed to 'routeA' based on the 'action'
    //         // property
    //         JSON.stringify({
    //           action: "redirect",
    //           data: "https://www.google.de"
    //         })
    //       );
    //     }, 1000);
    //   },
    //   disconnect() {
    //     // WebSocket sends a message to API Gateway that gets routed to the
    //     // '$disconnect' route.
    //     this.messages.push("client:    Closing the connection.");
    //     this.websocket.close();
    //   }
    // };
    // app.connect();
    const browser = detect();
    this.$store.commit("mediasoup/set_browserDetails", browser);
    logger.info(`Browser details:`, browser);
  },
  methods: {},
};
</script>
